import React from 'react';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, horizontalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';

import { getStoryMediaId } from '../../../../media/storyMediaItem';
import FilmstripItem from './FilmstripItem';

import scss from './SelectedMediaFilmstrip.module.scss';

function restrictToHorizontalAxis({ transform }) {
  if (!transform) {
    return transform;
  }

  return { ...transform, y: 0 };
}

function SelectedMediaFilmstrip({ items, activeId, onSelect, onRemove, onReorder }) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 4 } }),
    useSensor(KeyboardSensor),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return;
    }

    const oldIndex = items.findIndex((item) => getStoryMediaId(item) === active.id);
    const newIndex = items.findIndex((item) => getStoryMediaId(item) === over.id);

    if (oldIndex === -1 || newIndex === -1) {
      return;
    }

    onReorder(arrayMove(items, oldIndex, newIndex));
  };

  const itemIds = items.map(getStoryMediaId);

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      modifiers={[restrictToHorizontalAxis]}
      onDragEnd={handleDragEnd}>
      <SortableContext items={itemIds} strategy={horizontalListSortingStrategy}>
        <div className={scss.wrapper}>
          {items.map((item) => (
            <FilmstripItem
              key={getStoryMediaId(item)}
              media={item}
              isActive={getStoryMediaId(item) === activeId}
              onSelect={onSelect}
              onRemove={onRemove}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
}

export default SelectedMediaFilmstrip;
